import { render, staticRenderFns } from "./whatsappofficialsettings.vue?vue&type=template&id=087e8cab&"
import script from "./whatsappofficialsettings.vue?vue&type=script&lang=js&"
export * from "./whatsappofficialsettings.vue?vue&type=script&lang=js&"
import style0 from "./whatsappofficialsettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports